<template>
    <div v-if="isAllowed">
        <b-button :size="buttonSize" variant="primary" @click="openModal">
            <span v-if="isLoading" aria-hidden="true"
                class="spinner-border spinner-border-sm" role="status"/>
            {{ label }}
        </b-button>

        <b-modal v-model="isModalOpen" hide-footer size="lg"
            :title="label">
            <div v-if="isLoading" class="loading-content-container d-flex justify-content-center">
                <csp-loading-indicator/>
            </div>
            <div v-else class="info-card editMode">
                <b-row>
                    <b-col/>
                    <b-col>
                        <b>GDV Ergebnis</b>
                    </b-col>
                    <b-col>
                        <b>Portal Wert</b>
                    </b-col>
                    <b-col>
                        <b>Übernahme</b>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Datum des Unfalls</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="dateOfLoss"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="dateOfLoss"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="dateOfLoss"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Kennzeichen des Unfallgegners</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="licenceNumber"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="licenceNumber"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="licenceNumber"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Versicherungsscheinnummer des Unfallgegners</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePolicyNumber"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePolicyNumber"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePolicyNumber"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Name der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOName"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOName"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOName"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Straße der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOStreet"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOStreet"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOStreet"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Postleitzahl der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOZipCity"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOZipCity"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOZipCity"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Ort der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOCity"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOCity"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOCity"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Ansprechpartner der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOClerk"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOClerk"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOClerk"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Telefonnummer der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOTelephoneNo"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOTelephoneNo"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOTelephoneNo"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Faxnummer der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOFaxNo"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOFaxNo"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOFaxNo"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>Email-Adresse der Versicherungsfiliale</b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOEMail"
                            :hide-label="true"
                            property="serviceValue"
                            :required="false"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-input
                            class="info-card-element"
                            :form="insurancePOEMail"
                            :hide-label="true"
                            property="recordValue"
                            :required="true"
                            type="text"/>
                    </b-col>
                    <b-col>
                        <csp-form-group-checkbox :checked="false"
                            :form="insurancePOEMail"
                            :hide-label="true"
                            override-label=""
                            property="override"
                            unchecked-value="0"
                            value="1">
                            <template v-slot:label>
                                <span>&nbsp;</span>
                            </template>
                        </csp-form-group-checkbox>
                    </b-col>
                </b-row>

                <div class="form-group text-right">
                    <button class="btn btn-secondary" @click="isModalOpen = false;">
                        Abbrechen
                    </button>
                    <button class="btn btn-primary" @click="sendForm">
                        <span v-if="isUpdating" aria-hidden="true"
                            class="spinner-border spinner-border-sm" role="status"/>
                        Speichern
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>

    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import Container from '@services/Container';
    import Form from '@form/Form';
    const container = Container.getInstance();
    const ajaxService = container.getAjaxService();
    const flashMessenger = container.getFlashMessenger();
    const errorHandler = Container.getInstance().getErrorHandler();

    export default {
        name: 'ResponsibleInsuranceModal',
        mixins: [FormDataMixin],
        props: {
            recordId: {
                type: Number,
                required: true,
            },
            buttonSize: {
                type: String,
                default: 'md',
            },
        },
        emits: ['cancel-responsible-insurance', 'success-responsible-insurance', 'trigger-notes-reload'],
        data() {
            return {
                responsibleInsuranceForm: new Form({}),
                responsibleInsuranceRawData: {},
                isAllowed: false,
                isModalOpen: false,
                isLoading: false,
                isUpdating: false,
                label: 'GDV Abfrage',
                admissionOfficeRequestDesired: 0,
            }
        },
        computed: {
            dateOfLoss() {
                return this.responsibleInsuranceForm.getSubform('dateOfLoss')
            },
            licenceNumber() {
                return this.responsibleInsuranceForm.getSubform('licenceNumber')
            },
            insurancePolicyNumber() {
                return this.responsibleInsuranceForm.getSubform('insurancePolicyNumber')
            },
            insurancePOName() {
                return this.responsibleInsuranceForm.getSubform('insurancePOName')
            },
            insurancePOStreet() {
                return this.responsibleInsuranceForm.getSubform('insurancePOStreet')
            },
            insurancePOZipCity() {
                return this.responsibleInsuranceForm.getSubform('insurancePOZipCity')
            },
            insurancePOCity() {
                return this.responsibleInsuranceForm.getSubform('insurancePOCity')
            },
            insurancePOClerk() {
                return this.responsibleInsuranceForm.getSubform('insurancePOClerk')
            },
            insurancePOTelephoneNo() {
                return this.responsibleInsuranceForm.getSubform('insurancePOTelephoneNo')
            },
            insurancePOFaxNo() {
                return this.responsibleInsuranceForm.getSubform('insurancePOFaxNo')
            },
            insurancePOEMail() {
                return this.responsibleInsuranceForm.getSubform('insurancePOEMail')
            },
        },
        mounted() {
            this.checkResponsibleInsuranceRequestPermission();
        },
        methods: {
            buildFlashMessageOnError(error) {
                if (typeof error.getPropertyErrors === 'function') {
                    flashMessenger.addWarning(error.getPropertyErrors().join(' '));
                } else if (Object.hasOwn(error, 'errors') && Array.isArray(error.errors)) {
                    flashMessenger.addWarning(error.errors.join(' '));
                } else {
                    flashMessenger.addWarning('Ein unbekannter Fehler ist aufgetreten.');
                }
            },
            checkResponsibleInsuranceRequestPermission() {
                const path = '/de/Schaden-Manager/Akte/ajax' +
                    '/vehicleDamageRecordId/' + this.recordId + '/type/checkResponsibleInsuranceRequestPermission';
                ajaxService.getJson(path).then(
                    (data) => {
                        this.isAllowed = data.isAllowed === true;
                    });
            },
            openModal() {
                this.isLoading = true;
                let path = '/de/Schaden-Manager/Akte/ajax' +
                    '/vehicleDamageRecordId/' + this.recordId + '/type/responsibleInsuranceRequest';
                if (this.admissionOfficeRequestDesired === 1) {
                    path = path + '?admissionOfficeRequestDesired=1';
                }
                errorHandler.silenceValidationErrors();
                ajaxService.getJson(path).then(
                    (data) => {
                        if (Object.hasOwn(data, 'data')) {
                            this.responsibleInsuranceRawData = data.data.attributes;
                            this.responsibleInsuranceForm.setData(data.data.attributes);
                            this.isModalOpen = true;
                        } else {
                            // special cases for admissionOfficeRequest, which are NOT
                            // error cases
                            if (Object.hasOwn(data, 'showAdmissionOfficeRequestButton') &&
                                data.showAdmissionOfficeRequestButton === true) {
                                this.label = 'GDV Abfrage über Zulassungsstelle';
                                this.admissionOfficeRequestDesired = 1;
                                flashMessenger.addInfo(
                                    'Über die normale GDV Versicherungsabfrage liegen aktuell leider keine Daten vor. '
                                    +
                                        'Sie können allerdings eine weiterführende Abfrage über die ' +
                                        'Zulassungsstelle einleiten. ' +
                                        'Wurde bereits eine solche Abfrage gestellt, steht das Ergebnis momentan noch '
                                    +
                                        'nicht zur Verfügung.' +
                                        'Versuchen Sie es dann zu einem späteren Zeitpunkt erneut.'
                                )
                            } else if (Object.hasOwn(data, 'admissionOfficeRequestNote')) {
                                flashMessenger.addInfo(
                                    'Es wurde ein Vermerk über die Zulassungsstellenanfrage mit Wiedervorlage zum ' +
                                        data.admissionOfficeRequestNote + ' eingestellt. ' +
                                    'Sobald die Daten bei der GDV ' +
                                        'vorliegen, können diese über die normale GDV Versicherungsabfrage' +
                                    ' abgerufen werden.'
                                )
                            } else {
                                flashMessenger.addError('Ein unbekannter Fehler ist aufgetreten.');
                            }
                            this.$emit('trigger-notes-reload');
                        }
                        if (Object.hasOwn(data, 'infos') && Array.isArray(data.infos)) {
                            flashMessenger.addInfo(data.infos.join());
                        }
                        this.isLoading = false;
                        errorHandler.showValidationErrors();
                    },
                    (error) => {
                        this.buildFlashMessageOnError(error);
                        errorHandler.showValidationErrors();
                    });
            },
            sendForm() {
                this.isUpdating = true;

                const path = '/de/Schaden-Manager/Akte/ajax' +
                    '/vehicleDamageRecordId/' + this.recordId + '/type/responsibleInsuranceRequest';
                const formData = new FormData();

                const dateOfLoss =
                    this.responsibleInsuranceForm.getSubform('dateOfLoss').getData();
                formData.append('dateOfLoss[serviceValue]', dateOfLoss.serviceValue);
                formData.append('dateOfLoss[recordValue]', dateOfLoss.recordValue);
                formData.append('dateOfLoss[override]', dateOfLoss.override);

                const licenceNumber =
                    this.responsibleInsuranceForm.getSubform('licenceNumber').getData();
                formData.append('licenceNumber[serviceValue]', licenceNumber.serviceValue);
                formData.append('licenceNumber[recordValue]', licenceNumber.recordValue);
                formData.append('licenceNumber[override]', licenceNumber.override);

                const insurancePolicyNumber =
                    this.responsibleInsuranceForm.getSubform('insurancePolicyNumber').getData();
                formData.append('insurancePolicyNumber[serviceValue]', insurancePolicyNumber.serviceValue);
                formData.append('insurancePolicyNumber[recordValue]', insurancePolicyNumber.recordValue);
                formData.append('insurancePolicyNumber[override]', insurancePolicyNumber.override);

                const insurancePOName =
                    this.responsibleInsuranceForm.getSubform('insurancePOName').getData();
                formData.append('insurancePOName[serviceValue]', insurancePOName.serviceValue);
                formData.append('insurancePOName[recordValue]', insurancePOName.recordValue);
                formData.append('insurancePOName[override]', insurancePOName.override);

                const insurancePOStreet =
                    this.responsibleInsuranceForm.getSubform('insurancePOStreet').getData();
                formData.append('insurancePOStreet[serviceValue]', insurancePOStreet.serviceValue);
                formData.append('insurancePOStreet[recordValue]', insurancePOStreet.recordValue);
                formData.append('insurancePOStreet[override]', insurancePOStreet.override);

                const insurancePOZipCity =
                    this.responsibleInsuranceForm.getSubform('insurancePOZipCity').getData();
                formData.append('insurancePOZipCity[serviceValue]', insurancePOZipCity.serviceValue);
                formData.append('insurancePOZipCity[recordValue]', insurancePOZipCity.recordValue);
                formData.append('insurancePOZipCity[override]', insurancePOZipCity.override);

                const insurancePOCity =
                    this.responsibleInsuranceForm.getSubform('insurancePOCity').getData();
                formData.append('insurancePOCity[serviceValue]', insurancePOCity.serviceValue);
                formData.append('insurancePOCity[recordValue]', insurancePOCity.recordValue);
                formData.append('insurancePOCity[override]', insurancePOCity.override);

                const insurancePOClerk =
                    this.responsibleInsuranceForm.getSubform('insurancePOClerk').getData();
                formData.append('insurancePOClerk[serviceValue]', insurancePOClerk.serviceValue);
                formData.append('insurancePOClerk[recordValue]', insurancePOClerk.recordValue);
                formData.append('insurancePOClerk[override]', insurancePOClerk.override);

                const insurancePOTelephoneNo =
                    this.responsibleInsuranceForm.getSubform('insurancePOTelephoneNo').getData();
                formData.append('insurancePOTelephoneNo[serviceValue]', insurancePOTelephoneNo.serviceValue);
                formData.append('insurancePOTelephoneNo[recordValue]', insurancePOTelephoneNo.recordValue);
                formData.append('insurancePOTelephoneNo[override]', insurancePOTelephoneNo.override);

                const insurancePOFaxNo =
                    this.responsibleInsuranceForm.getSubform('insurancePOFaxNo').getData();
                formData.append('insurancePOFaxNo[serviceValue]', insurancePOFaxNo.serviceValue);
                formData.append('insurancePOFaxNo[recordValue]', insurancePOFaxNo.recordValue);
                formData.append('insurancePOFaxNo[override]', insurancePOFaxNo.override);

                const insurancePOEMail =
                    this.responsibleInsuranceForm.getSubform('insurancePOEMail').getData();
                formData.append('insurancePOEMail[serviceValue]', insurancePOEMail.serviceValue);
                formData.append('insurancePOEMail[recordValue]', insurancePOEMail.recordValue);
                formData.append('insurancePOEMail[override]', insurancePOEMail.override);

                // sending and error handling
                return ajaxService.postFormDataPlain(path, formData).then(
                    (data) => {
                        flashMessenger.addSuccess('Datenübernahme erfolgreich');
                        if (Object.hasOwn(data, 'infos') && Array.isArray(data.infos)) {
                            flashMessenger.addInfo(data.infos.join(' '));
                        }
                        this.isUpdating = false;
                        this.isModalOpen = false;
                        this.$emit('success-responsible-insurance');
                    },
                    (error) => {
                        this.responsibleInsuranceForm.setValidationErrors(error);
                        this.buildFlashMessageOnError(error);
                        this.isUpdating = false;
                    }
                );
            },
        },
    }

</script>
